import { render, staticRenderFns } from "./EditPuzzle.vue?vue&type=template&id=7e69d066&"
import script from "./EditPuzzle.vue?vue&type=script&lang=js&"
export * from "./EditPuzzle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports